/** Spec §14.2 page 11: workers, last good backup, software version, alert delivery readiness. */
import { useBackups, useHealth } from "../api/hooks.js";
import { StateBadge } from "../components/StateBadge.js";
import { PageState } from "../components/PageState.js";

export function SystemDiagnosticsPage() {
  const health = useHealth();
  const backups = useBackups();

  return (
    <PageState query={{ isPending: health.isPending, error: health.error }}>
      <div className="grid">
        <div className="card"><h3>API status</h3><div className="value">{health.data?.status ?? "unknown"}</div></div>
        <div className="card"><h3>Database</h3><div className="value">{health.data?.database ? "reachable" : "unreachable"}</div></div>
        <div className="card"><h3>Audio flag</h3><div className="value">{health.data?.audio_capture_enabled ? "enabled" : "disabled"}</div></div>
        <div className="card"><h3>Sessions</h3><div className="value">{health.data?.session_store_size ?? 0}</div></div>
        <div className="card">
          <h3>Headset control</h3>
          <div className="value">{health.data?.transport_mode ?? "unknown"}</div>
          <p className="muted mono">transport {health.data?.device_transport ?? "—"}</p>
        </div>
      </div>
      <p className="muted mono">server time {health.data?.server_time_iso ?? "—"}</p>
      <section>
        <h3>Backups</h3>
        {(backups.data ?? []).length === 0 ? (
          <p className="notice">No backup manifests recorded — run make backup.</p>
        ) : (
          <table>
            <thead><tr><th>Backup</th><th>Created</th><th>Verification</th><th>Restore test</th></tr></thead>
            <tbody>
              {(backups.data ?? []).map((b) => (
                <tr key={b.backup_id}>
                  <td className="mono">{b.backup_id}</td>
                  <td>{new Date(b.created_at).toLocaleString()}</td>
                  <td><StateBadge state={b.verification_status} /></td>
                  <td>{b.restoration_test_at ? new Date(b.restoration_test_at).toLocaleString() : "not tested"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
      <p className="notice warn">
        Quest capability regressions are reported on the Devices page after each firmware probe; untested means
        no physical headset evidence exists yet.
      </p>
    </PageState>
  );
}
